import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneChild from "./OneChild";

import child1 from '../assets/children/child1.jpg';
import child2 from '../assets/children/child2.jpg';
import child3 from '../assets/children/child3.jpg';
import child4 from '../assets/children/child4.png';

export default function ChildrenContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const children = [
  {
    id: 1,
    name: "Amina Yusuf",
    age: 7,
    status: "Blind",
    image: child1
  },
  {
    id: 2,
    name: "Baraka Mwita",
    age: 9,
    status: "Mental illness",
    image: child2
  },
  {
    id: 3,
    name: "Zawadi Selemani",
    age: 6,
    status: "Deaf",
    image: child3
  },
  {
    id: 4,
    name: "Juma Kileo",
    age: 10,
    status: "Cerebral Palsy",
    image: child4
  }
];


  async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading py-5">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div 
      className="MainBodySection bg-background"
      style={{
        paddingTop: "20px",
        paddingBottom: "50px"
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center mb-4">
            <h2 className="main-section-title">
              Children in Need
              <span
                style={{
                  display: "block",
                  borderBottom: "3px solid var(--secondaryColor)",
                  width: "80px",
                  margin: "10px auto"
                }}
              ></span>
            </h2>
            <p className="text-muted">
              Meet the children we support. Your donation changes lives.
            </p>
          </div>

          {children.map((child, index) => (
            <div 
              className="col-md-6 col-lg-3 mb-4" 
              key={child.id}
            >
              <OneChild
                name={child.name}
                age={child.age}
                nationality={child.nationality}
                status={child.status}
                image={child.image}
                navToLink={{
                  item: 'donations', // ← This navigates to your donation page
                  childId: child.id  // Optional: pass child context
                }}
              />
            </div>
          ))}

          {/* Optional: CTA at bottom */}
          <div className="col-12 text-center mt-5">
            <button
              className="btn btn-secondary btn-lg px-5 py-3 fw-bold"
              onClick={() => appContext.navTo({ item: 'donations' })}
            >
              <i className="bi bi-heart me-2"></i>
              Support a Child Today
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}